export default __webpack_public_path__ + "static/media/Group 3189@2x.283d70e9.png";